import Experience from '../../Experience.js'
import * as THREE from 'three'

export default class Environment {
    constructor()
    {
        // Setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.loader.items

        // Instantiate Methods
        this.setSkyLight()
        this.setEnvironmentMap()
    }

    // Instantiate Methods
    setSkyLight()
    {
        this.skylight = new THREE.DirectionalLight(0xffffff, 1.013)

        // Shadows
        this.skylight.castShadow = true
        this.skylight.shadow.camera.far = 15
        this.skylight.shadow.mapSize.set(1024, 1024)
        this.skylight.shadow.normalBias = 0.05

        this.skylight.position.set(-5, -1.27, -0.38)
        this.scene.add(this.skylight)
    }

    setEnvironmentMap()
    {
        this.environmentMap = {}
        this.environmentMap.intensity = 1.5
        this.environmentMap.texture = this.resources.environmentMapTexture

        this.scene.environment = this.environmentMap.texture
        this.scene.background  = this.environmentMap.texture

        this.updateMaterials()
    }

    // Helper Methods
    updateMaterials()
    {
        this.scene.traverse((child) => {
            if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
            {
                child.material.envMap = this.environmentMap.texture
                child.material.envMapIntensity = this.environmentMap.intensity
                child.material.needsUpdate = true
            }
        })
    }
}